import { inject, Injectable } from '@angular/core';
import { ApiHttpClient } from '@fullyops/shared/services/api-http-client.service';
import { AssetCategory, AssetCategoryInput } from './asset-category';

const apiPath = 'assets/categories';

@Injectable({ providedIn: 'root' })
export class ApiAssetCategoriesAdapterService {
  private api = inject(ApiHttpClient);

  readonly getAll = this.api.allGetter<AssetCategory>(apiPath);
  readonly create = this.api.creator<AssetCategoryInput>(apiPath);
  readonly delete = this.api.deleter(apiPath);
}
